window.addEventListener('load', () => {
  if(document.body.classList.contains('template-cart')) {
      const checkoutBtn = document.querySelector('#checkout-btn');
      const agreeBtn = document.querySelector('#agree');

      checkoutBtn.classList.add('disabled-btn');
      checkoutBtn.disabled = true;

      agreeBtn.addEventListener('click', () => {
         const check = agreeBtn.checked;

          if(check) {
              checkoutBtn.disabled = false;
              checkoutBtn.classList.remove('disabled-btn');
          } else {
              checkoutBtn.disabled = true;
              checkoutBtn.classList.add('disabled-btn');
          }

      })
  }
  
  // SINGLE PRODUCT PAGE: ADD DROPDOWN ICON IF SELECT OPTION IS MORE THAN 1
  if(document.body.classList.contains('template-product')) {
    const select = document.querySelectorAll('.single-option-selector');

    [...select].forEach(s => {
      if(s.length > 1) {
        s.classList.add('select-more-option');
      }
    })
  }

  // REMOVE TYPE FILTER IN ALL COLLECTION PAGE
  if(document.body.classList.contains('template-collection')) {

    const url = window.location;
    const allCollections = `${url.origin}${url.pathname}`

    if(url.href === allCollections) {
      const typeFilter = document.querySelectorAll("[data-type='opt_type']");
      
      if(typeFilter[0]) {
        typeFilter[0].classList.add('hide-filter');
      }
      
    }
  }

  // SEARCHBOX PLACEHOLDER
  
  const searchBox = document.querySelectorAll('.bc-sf-search-box');
  
  [...searchBox].forEach(s => {
  	s.placeholder = "Search";
  })
  
  // CUSTOM HERO BACKGROUND
  if(document.querySelector('.custom-hero')) {
      const heroBG = document.querySelector('.custom-hero');
      const herostyle = heroBG.currentStyle || window.getComputedStyle(heroBG, false);
      const imgURL = herostyle.backgroundImage.slice(4, -1).replace(/"/g, "");
      const heroSection = document.querySelector('#shopify-section-1611201049afd6a552');

      heroSection.style.backgroundImage = `url(${imgURL})`;
  }
              
  // PHOTO GALLERY
  
  //   setTimeout(() => {
  //       const waterMark = document.querySelector('.ndn-album span');
  // 	  waterMark.remove();
  //   }, 5000)

  // SMART MENU / MEGAMENU

  const tMenu = document.querySelectorAll('.tmenu_item');

  [...tMenu].forEach(m => {
    m.addEventListener('mouseover', () => {
      const waterMark = document.querySelector('.tmenu-watermark');
      
      if(waterMark) {
      	waterMark.remove();
      }
    })
  })


})